(function(){
'use strict';
const CFG=window.ShopifyChatConfig;
if(!CFG)return;
const B=CFG.brand,UI=CFG.ui;

/* ── CSS ── */
const CSS=`
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');
:root{
  --p:${B.primary};--a:${B.accent};--l:${B.light};
  --bot:${B.bubbleBot};--tx:${B.textMain};--sub:${B.textSub};
  --err:${B.error};--errBg:${B.errorBg};--errBd:${B.errorBorder};
  --ok:${B.ok};--okBg:${B.okBg};
  --f:'Noto Sans JP','Hiragino Sans',sans-serif;
  --r:16px;
  --sh:0 14px 52px rgba(0,0,0,.22),0 2px 8px rgba(0,0,0,.12);
}
#cbf{
  position:fixed;right:18px;bottom:22px;z-index:99990;
  display:flex;align-items:center;gap:10px;
  background:var(--p);color:#fff;border:none;border-radius:50px;
  padding:13px 20px 13px 14px;cursor:pointer;
  box-shadow:0 6px 28px rgba(0,0,0,.35);
  font-family:var(--f);font-size:13.5px;font-weight:700;letter-spacing:.04em;
  transition:transform .2s,box-shadow .2s;outline:none;user-select:none;
}
#cbf:hover{transform:translateY(-3px);box-shadow:0 10px 36px rgba(0,0,0,.45)}
#cbf:active{transform:scale(.96)}
.cbfi{width:30px;height:30px;background:var(--a);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:15px;flex-shrink:0}
.cbfd{position:absolute;top:-3px;right:-3px;width:11px;height:11px;background:#e05c40;border-radius:50%;border:2px solid #fff;animation:cbPulse 2.2s ease-in-out infinite}
@keyframes cbPulse{0%,100%{transform:scale(1);opacity:1}50%{transform:scale(1.5);opacity:.6}}
#cbw{
  position:fixed;right:14px;bottom:84px;
  width:378px;max-width:calc(100vw - 28px);
  height:640px;max-height:calc(100dvh - 110px);
  background:var(--l);border-radius:22px;box-shadow:var(--sh);
  z-index:99991;display:flex;flex-direction:column;overflow:hidden;
  font-family:var(--f);
  transform:translateY(24px) scale(.94);opacity:0;pointer-events:none;
  transition:transform .3s cubic-bezier(.34,1.56,.64,1),opacity .22s ease;
}
#cbw.open{transform:translateY(0) scale(1);opacity:1;pointer-events:all}
.cbh{background:var(--p);padding:15px 15px 13px;display:flex;align-items:center;gap:11px;flex-shrink:0}
.cbha{width:40px;height:40px;background:var(--a);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;box-shadow:0 2px 8px rgba(0,0,0,.3)}
.cbhi{flex:1;overflow:hidden}
.cbht{font-size:14.5px;font-weight:700;color:#fff;letter-spacing:.02em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.cbhs{font-size:11px;color:rgba(255,255,255,.5);margin-top:2px}
.cbcl{width:30px;height:30px;background:rgba(255,255,255,.12);border:none;color:rgba(255,255,255,.8);border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:13px;flex-shrink:0;transition:background .15s}
.cbcl:hover{background:rgba(255,255,255,.25)}
.cbpw{height:3px;background:rgba(238,119,0,.2);flex-shrink:0}
.cbpb{height:100%;background:var(--a);transition:width .45s cubic-bezier(.4,0,.2,1)}
.cbsl{font-size:11px;color:var(--sub);text-align:right;padding:5px 14px 2px;flex-shrink:0;letter-spacing:.04em;font-weight:500}
.cbm{flex:1;overflow-y:auto;padding:10px 13px 6px;display:flex;flex-direction:column;gap:9px;scroll-behavior:smooth}
.cbm::-webkit-scrollbar{width:4px}
.cbm::-webkit-scrollbar-thumb{background:#ddd;border-radius:2px}
.cbb{max-width:86%;padding:10px 14px;font-size:13.5px;line-height:1.65;word-break:break-word;white-space:pre-wrap;animation:cbPop .2s ease;border-radius:var(--r)}
@keyframes cbPop{from{transform:scale(.88) translateY(8px);opacity:0}to{transform:scale(1) translateY(0);opacity:1}}
.cbb.bot{background:var(--bot);color:var(--tx);border-bottom-left-radius:4px;align-self:flex-start;box-shadow:0 1px 5px rgba(0,0,0,.08)}
.cbb.usr{background:var(--p);color:#fff;border-bottom-right-radius:4px;align-self:flex-end;font-weight:500}
.cbb.err{background:var(--errBg);color:var(--err);border:1.5px solid var(--errBd);border-radius:12px;align-self:flex-start;max-width:92%}
.cbb.ok2{background:var(--okBg);color:var(--ok);border:1.5px solid #86efac;border-radius:12px;align-self:flex-start;max-width:92%}
.cbt{display:flex;gap:5px;align-items:center;padding:11px 14px;background:var(--bot);border-radius:var(--r);border-bottom-left-radius:4px;align-self:flex-start;box-shadow:0 1px 5px rgba(0,0,0,.07);width:56px}
.cbt span{width:7px;height:7px;background:#ccc;border-radius:50%;animation:cbDot 1.3s ease-in-out infinite}
.cbt span:nth-child(2){animation-delay:.2s}
.cbt span:nth-child(3){animation-delay:.4s}
@keyframes cbDot{0%,60%,100%{transform:translateY(0);background:#ccc}30%{transform:translateY(-7px);background:var(--a)}}
.cbia{background:#fff;border-top:1px solid #eee;padding:12px;flex-shrink:0;display:flex;flex-direction:column;gap:8px}
.cb-back-row{display:flex;align-items:center}
.cb-back{background:none;border:none;color:var(--sub);font-size:12px;font-family:var(--f);cursor:pointer;display:flex;align-items:center;gap:4px;padding:3px 0;transition:color .15s}
.cb-back:hover{color:var(--a)}
.cb-back svg{width:14px;height:14px;flex-shrink:0}
.cbcs{display:flex;flex-direction:column;gap:7px}
.cbcc{display:flex;align-items:center;gap:10px;background:#fff;border:2px solid #e5e5e5;border-radius:12px;padding:11px 13px;cursor:pointer;transition:all .15s;text-align:left;width:100%;font-family:var(--f)}
.cbcc:hover{border-color:var(--a);background:#fff8f0;transform:translateX(2px)}
.cbcc:active{transform:scale(.98)}
.cbcic{font-size:18px;flex-shrink:0;width:34px;height:34px;display:flex;align-items:center;justify-content:center;background:var(--l);border-radius:9px}
.cbcn{flex:1;min-width:0}
.cbcl2{font-size:13px;font-weight:700;color:var(--tx);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.cbcdc{font-size:11px;color:var(--sub);margin-top:2px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.cbcpr{font-size:13px;font-weight:700;color:var(--a);flex-shrink:0;margin-left:4px;white-space:nowrap}
/* 定期バッジ */
.cb-sub-badge{display:inline-block;background:var(--a);color:#fff;font-size:9px;font-weight:700;padding:2px 6px;border-radius:4px;margin-left:5px;vertical-align:middle;letter-spacing:.03em}
.cb-pm-notice{padding:9px 12px;background:linear-gradient(135deg,rgba(0,0,0,.03),rgba(238,119,0,.06));border:1px solid rgba(238,119,0,.2);border-radius:10px;font-size:11.5px;color:var(--sub);line-height:1.6;display:flex;gap:7px;align-items:flex-start}
.cb-pm-notice-icon{font-size:14px;flex-shrink:0;margin-top:1px}
.cbyn{display:flex;gap:8px}
.cbynb{flex:1;padding:12px;border-radius:12px;border:2px solid;font-size:13px;font-weight:700;cursor:pointer;font-family:var(--f);transition:all .15s}
.cbyny{border-color:var(--p);background:var(--p);color:#fff}
.cbyny:hover{background:var(--a);border-color:var(--a)}
.cbynn{border-color:#e5e5e5;background:#fff;color:var(--sub)}
.cbynn:hover{border-color:var(--sub)}
.cbtr{display:flex;gap:8px;align-items:flex-end}
.cbti{flex:1;border:2px solid #e5e5e5;border-radius:12px;padding:11px 14px;font-size:14px;font-family:var(--f);outline:none;background:#fff;color:var(--tx);transition:border-color .15s}
.cbti:focus{border-color:var(--a)}
.cbti.invalid{border-color:var(--err)!important;background:#fff9f9}
.cbsb{width:44px;height:44px;background:var(--p);color:#fff;border:none;border-radius:12px;cursor:pointer;font-size:17px;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:background .15s,transform .1s}
.cbsb:hover{background:var(--a)}
.cbsb:active{transform:scale(.92)}
.cb-hint{font-size:11.5px;color:var(--sub);margin-top:4px;padding:0 2px}
.cb-skip-row{text-align:right}
.cb-skip{font-size:11.5px;color:var(--sub);background:none;border:none;text-decoration:underline;cursor:pointer;font-family:var(--f)}
.cb-skip:hover{color:var(--a)}
.cb-zip-result{display:flex;align-items:center;gap:8px;padding:9px 12px;background:var(--okBg);border:1.5px solid #86efac;border-radius:10px;font-size:12.5px;color:var(--ok);font-weight:500}
.cb-zip-result svg{flex-shrink:0;width:16px;height:16px}
.cb-zip-edit{font-size:11.5px;color:var(--sub);text-decoration:underline;cursor:pointer;background:none;border:none;font-family:var(--f);margin-left:auto;flex-shrink:0}
.cb-zip-edit:hover{color:var(--a)}
.cbstw{display:flex;flex-direction:column;gap:8px}
.cbst{display:flex;align-items:center;border:2px solid var(--p);border-radius:12px;overflow:hidden;width:fit-content}
.cbst button{width:44px;height:44px;background:#fff;border:none;font-size:22px;font-weight:700;color:var(--p);cursor:pointer;transition:background .1s;line-height:1}
.cbst button:hover{background:var(--l)}
.cbstv{width:52px;text-align:center;font-size:18px;font-weight:700;color:var(--p);font-family:var(--f);border-left:1px solid #e5e5e5;border-right:1px solid #e5e5e5;height:44px;line-height:44px}
.cbstok{width:100%;background:var(--p);color:#fff;border:none;border-radius:12px;padding:12px;font-size:14px;font-weight:700;cursor:pointer;font-family:var(--f);transition:background .15s}
.cbstok:hover{background:var(--a)}
.cbsum{background:var(--l);border:1.5px solid #e5e5e5;border-radius:14px;overflow:hidden;margin-bottom:10px}
.cbsec{padding:7px 14px 4px;font-size:10.5px;font-weight:700;color:var(--a);letter-spacing:.08em;border-top:1px solid #e5e5e5}
.cbsec:first-child{border-top:none}
.cbsr{display:flex;padding:6px 14px;font-size:12.5px;gap:8px}
.cbsk2{color:var(--sub);flex-shrink:0;min-width:84px}
.cbsv{color:var(--tx);font-weight:500;word-break:break-all}
.cbcb{display:flex;gap:8px}
.cbcok{flex:2;background:var(--p);color:#fff;border:none;border-radius:12px;padding:13px;font-size:13.5px;font-weight:700;cursor:pointer;font-family:var(--f);transition:background .15s}
.cbcok:hover{background:var(--a)}
.cbcbk{flex:1;background:#fff;color:var(--sub);border:1.5px solid #e5e5e5;border-radius:12px;padding:13px;font-size:12px;cursor:pointer;font-family:var(--f)}
.cbld{display:flex;align-items:center;justify-content:center;gap:8px;padding:16px;font-size:13px;color:var(--sub)}
.cbspinner{width:18px;height:18px;border:2.5px solid #e5e5e5;border-top-color:var(--a);border-radius:50%;animation:cbSpin .75s linear infinite}
@keyframes cbSpin{to{transform:rotate(360deg)}}
.cb-guide-card{background:var(--l);border:1.5px solid #e5e5e5;border-radius:14px;padding:14px;display:flex;flex-direction:column;gap:10px}
.cb-guide-icon{font-size:28px;text-align:center}
.cb-guide-text{font-size:13px;color:var(--tx);line-height:1.7;text-align:center;white-space:pre-wrap}
.cb-guide-btns{display:flex;flex-direction:column;gap:7px}
.cb-guide-open{background:var(--a);color:#fff;border:none;border-radius:12px;padding:13px;font-size:13.5px;font-weight:700;cursor:pointer;font-family:var(--f);display:flex;align-items:center;justify-content:center;gap:6px;transition:opacity .15s}
.cb-guide-open:hover{opacity:.88}
.cb-waiting{display:flex;flex-direction:column;align-items:center;gap:12px;padding:16px}
.cb-waiting-spinner{width:32px;height:32px;border:3px solid #e5e5e5;border-top-color:var(--a);border-radius:50%;animation:cbSpin .8s linear infinite}
.cb-waiting-text{font-size:13px;color:var(--sub);text-align:center;line-height:1.7}
.cb-waiting-text strong{color:var(--tx)}
.cb-waiting-done{background:var(--p);color:#fff;border:none;border-radius:12px;padding:13px 24px;font-size:13.5px;font-weight:700;cursor:pointer;font-family:var(--f);transition:background .15s;width:100%}
.cb-waiting-done:hover{background:var(--a)}
.cbsc{display:flex;flex-direction:column;align-items:center;padding:36px 20px;gap:14px;text-align:center}
.cbsr2{width:72px;height:72px;border-radius:50%;background:linear-gradient(135deg,var(--p),var(--a));display:flex;align-items:center;justify-content:center;font-size:30px;animation:cbPop .4s cubic-bezier(.34,1.56,.64,1);box-shadow:0 6px 24px rgba(238,119,0,.35)}
.cbst2{font-size:19px;font-weight:700;color:var(--tx)}
.cbsb2{font-size:13px;color:var(--sub);line-height:1.7}
`;
const st=document.createElement('style');st.textContent=CSS;document.head.appendChild(st);

/* ── DOM ── */
const fab=document.createElement('button');fab.id='cbf';
fab.innerHTML=`<span class="cbfi">${UI.botAvatar}</span><span>${UI.fabLabel}</span><span class="cbfd"></span>`;
document.body.appendChild(fab);

const win=document.createElement('div');win.id='cbw';
win.innerHTML=`
  <div class="cbh">
    <div class="cbha">${UI.botAvatar}</div>
    <div class="cbhi">
      <div class="cbht">${UI.headerTitle}</div>
      <div class="cbhs">${UI.headerSub}</div>
    </div>
    <button class="cbcl" id="cbcl">✕</button>
  </div>
  <div class="cbpw"><div class="cbpb" id="cbpb" style="width:0%"></div></div>
  <div class="cbsl" id="cbsl"></div>
  <div class="cbm" id="cbm"></div>
  <div class="cbia" id="cbia"></div>`;
document.body.appendChild(win);

/* ── STATE ── */
const S={open:false,started:false,answers:{},idx:0,history:[]};

/* ── FLOW ── */
const FLOW=[
  {id:'g1',       type:'msg',  text:'いらっしゃいませ！🥩\nmonster-deri へようこそ。\nチャットでサクッとご注文いただけます。'},
  {id:'g2',       type:'msg',  text:'いくつかの質問に答えるだけで完了します 👇'},
  {id:'product',  type:'product_select', label:'ご希望の商品をお選びください'},
  {id:'qty',      type:'number', label:'数量を選択してください', min:1, max:10, default:1},
  {id:'sep1',     type:'msg',  text:'📋 お客様情報をご入力ください'},
  {id:'name',     type:'text', label:'お名前（フルネーム）', placeholder:'山田 太郎',
    validate:v=>v.trim().length<2?'お名前は2文字以上で入力してください':null},
  {id:'email',    type:'email', label:'メールアドレス', placeholder:'example@email.com',
    validate:v=>!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)?'正しいメールアドレスを入力してください':null},
  {id:'phone',    type:'tel',  label:'お電話番号', placeholder:'09000000000',
    hint:'ハイフンなし 10〜11桁',
    validate:v=>{const d=v.replace(/[-\s]/g,'');return!/^\d{10,11}$/.test(d)?'電話番号は10〜11桁の数字で入力してください':null;}},
  {id:'zip',      type:'zip',  label:'郵便番号', placeholder:'1234567',
    hint:'ハイフンなし 7桁',
    validate:v=>!/^\d{7}$/.test(v.replace(/-/g,''))?'郵便番号は7桁の数字で入力してください':null,
    zipTarget:'billing'},
  {id:'addr',     type:'text', label:'住所（都道府県〜番地）', placeholder:'東京都渋谷区○○1-2-3',
    hint:'番地まで入力してください（例：1-2-3）',
    validate:v=>!/[\d０-９一二三四五六七八九十百千]/.test(v)?'番地まで入力してください（例：渋谷区〇〇1-2-3）':null},
  {id:'addr2',    type:'text', label:'マンション名・部屋番号', placeholder:'△△マンション 201号室', optional:true},
  {id:'diff_ask', type:'yn',   label:'お届け先は上記住所と\n異なりますか？'},
  {id:'sep_ship', type:'msg',  text:'📦 お届け先住所を入力してください', cond:'diff_yes'},
  {id:'ship_name',type:'text', label:'お届け先のお名前', placeholder:'山田 花子', cond:'diff_yes',
    validate:v=>v.trim().length<2?'2文字以上で入力してください':null},
  {id:'ship_zip', type:'zip',  label:'お届け先の郵便番号', placeholder:'9876543', cond:'diff_yes',
    hint:'ハイフンなし 7桁',
    validate:v=>!/^\d{7}$/.test(v.replace(/-/g,''))?'郵便番号は7桁の数字で入力してください':null,
    zipTarget:'shipping'},
  {id:'ship_addr',type:'text', label:'お届け先の住所', placeholder:'大阪府大阪市〇〇2-3-4', cond:'diff_yes',
    hint:'番地まで入力してください',
    validate:v=>!/[\d０-９一二三四五六七八九十百千]/.test(v)?'番地まで入力してください':null},
  {id:'ship_addr2',type:'text',label:'お届け先の建物名', placeholder:'□□ビル 5F', cond:'diff_yes', optional:true},
  {id:'payment',  type:'payment_select', label:'お支払い方法をお選びください'},
  {id:'confirm',  type:'confirm', label:'ご注文内容をご確認ください'},
];
const TOTAL=FLOW.filter(s=>s.type!=='msg').length;

/* ── HELPERS ── */
const $m=()=>document.getElementById('cbm');
const $i=()=>document.getElementById('cbia');
const $p=()=>document.getElementById('cbpb');
const $l=()=>document.getElementById('cbsl');
const fmt=n=>'¥'+Number(n).toLocaleString();
const scrollB=()=>setTimeout(()=>{$m().scrollTop=$m().scrollHeight},60);
const SVG_BACK=`<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 15l-5-5 5-5"/></svg>`;
const SVG_EXT=`<svg width="13" height="13" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 3h3v3M10 10l7-7M4 7h9v9H4z"/></svg>`;

function bubble(text,cls='bot'){
  const d=document.createElement('div');d.className='cbb '+cls;d.textContent=text;
  $m().appendChild(d);scrollB();
}
function showTyping(){rmTyping();const t=document.createElement('div');t.className='cbt';t.id='cbt';t.innerHTML='<span></span><span></span><span></span>';$m().appendChild(t);scrollB();}
function rmTyping(){const t=document.getElementById('cbt');if(t)t.remove();}
function setProgress(idx){
  const done=FLOW.slice(0,idx+1).filter(s=>s.type!=='msg').length;
  $p().style.width=Math.min(100,Math.round(done/TOTAL*100))+'%';
  $l().textContent=(done>0&&done<TOTAL)?`STEP ${done} / ${TOTAL}`:'';
}
function condSkip(step){
  if(!step.cond)return false;
  if(step.cond==='diff_yes')return S.answers['diff_ask']!=='yes';
  return false;
}
function makeBackRow(onBack){
  const row=document.createElement('div');row.className='cb-back-row';
  const btn=document.createElement('button');btn.className='cb-back';
  btn.innerHTML=SVG_BACK+'ひとつ前に戻る';btn.onclick=onBack;
  row.appendChild(btn);return row;
}
function goBack(){
  if(S.history.length===0)return;
  const prevIdx=S.history.pop();
  const step=FLOW[prevIdx];
  if(step&&step.id)delete S.answers[step.id];
  $i().innerHTML='';
  run(prevIdx,true);
}

/* ── FLOW ENGINE ── */
function run(idx,isBack=false){
  if(idx>=FLOW.length)return;
  S.idx=idx;
  const step=FLOW[idx];
  if(condSkip(step)){run(idx+1,isBack);return;}
  setProgress(idx);
  if(step.type==='msg'){
    if(!isBack){showTyping();setTimeout(()=>{rmTyping();bubble(step.text);run(idx+1);},800);}
    else run(idx+1,true);
    return;
  }
  if(!isBack){showTyping();setTimeout(()=>{rmTyping();bubble(step.label);renderInput(step,idx);},500);}
  else{bubble(step.label);renderInput(step,idx);}
}
function next(idx,txt){
  if(txt)bubble(txt,'usr');
  S.history.push(idx);$i().innerHTML='';run(idx+1);
}

/* ── INPUT RENDERERS ── */
function renderInput(step,idx){
  const area=$i();area.innerHTML='';
  const addBack=()=>{if(S.history.length>0||idx>2)area.appendChild(makeBackRow(goBack));};

  switch(step.type){

    case 'product_select':{
      const w=document.createElement('div');w.className='cbcs';
      CFG.products.forEach(p=>{
        const b=document.createElement('button');b.className='cbcc';
        const isSub=!!p.sellingPlan;
        const badge=isSub?'<span class="cb-sub-badge">定期</span>':'';
        b.innerHTML=`<span class="cbcic">${isSub?'🔄':'🥩'}</span><span class="cbcn"><span class="cbcl2">${p.label}${badge}</span><span class="cbcdc">${p.desc}</span></span><span class="cbcpr">${fmt(p.price)}</span>`;
        b.onclick=()=>{
          S.answers.product_id=p.variantId;
          S.answers.product_label=p.label;
          S.answers.product_price=p.price;
          S.answers.product_selling_plan=p.sellingPlan||null;
          S.answers.product_is_sub=isSub;
          next(idx,p.label+'  '+fmt(p.price));
        };
        w.appendChild(b);
      });
      area.appendChild(w);addBack();
      break;
    }

    case 'payment_select':{
      const w=document.createElement('div');w.className='cbcs';
      CFG.paymentMethods.forEach(pm=>{
        const b=document.createElement('button');b.className='cbcc';
        b.innerHTML=`<span class="cbcic">${pm.icon}</span><span class="cbcn"><span class="cbcl2">${pm.label}</span><span class="cbcdc">${pm.desc}</span></span>`;
        b.onclick=()=>{
          S.answers.payment_id=pm.id;
          S.answers.payment_label=pm.label;
          S.answers.payment_guide=pm.guide;
          next(idx,pm.label);
        };
        w.appendChild(b);
      });
      const note=document.createElement('div');note.className='cb-pm-notice';
      note.innerHTML=`<span class="cb-pm-notice-icon">🔒</span><span>カード番号などの決済情報はShopifyの安全な画面で入力します。このチャットへの入力は不要です。</span>`;
      area.appendChild(w);area.appendChild(note);addBack();
      break;
    }

    case 'number':{
      let val=step.default||1;
      const w=document.createElement('div');w.className='cbstw';
      const st2=document.createElement('div');st2.className='cbst';
      st2.innerHTML=`<button id="cbminus">−</button><div class="cbstv" id="cbnv">${val}</div><button id="cbplus">＋</button>`;
      const ok=document.createElement('button');ok.className='cbstok';ok.textContent='この数量で決定する';
      ok.onclick=()=>{S.answers.qty=val;next(idx,val+'個');};
      w.appendChild(st2);w.appendChild(ok);area.appendChild(w);addBack();
      setTimeout(()=>{
        document.getElementById('cbminus').onclick=()=>{val=Math.max(step.min,val-1);document.getElementById('cbnv').textContent=val;};
        document.getElementById('cbplus').onclick=()=>{val=Math.min(step.max,val+1);document.getElementById('cbnv').textContent=val;};
      },0);
      break;
    }

    case 'yn':{
      const row=document.createElement('div');row.className='cbyn';
      const yes=document.createElement('button');yes.className='cbynb cbyny';yes.textContent='はい（別の住所へ）';
      yes.onclick=()=>{S.answers[step.id]='yes';next(idx,'はい');};
      const no=document.createElement('button');no.className='cbynb cbynn';no.textContent='いいえ（同じ住所）';
      no.onclick=()=>{S.answers[step.id]='no';next(idx,'いいえ');};
      row.appendChild(yes);row.appendChild(no);area.appendChild(row);addBack();
      break;
    }

    case 'zip':{renderZip(area,step,idx);addBack();break;}
    case 'confirm':{renderConfirm(idx);break;}

    default:{
      const t=step.type==='email'?'email':step.type==='tel'?'tel':'text';
      renderText(area,step,idx,t);addBack();
    }
  }
  scrollB();
}

/* ── テキスト入力 ── */
function renderText(area,step,idx,type){
  const row=document.createElement('div');row.className='cbtr';
  const inp=document.createElement('input');inp.type=type;inp.className='cbti';inp.placeholder=step.placeholder||'';
  if(S.answers[step.id])inp.value=S.answers[step.id];
  const btn=document.createElement('button');btn.className='cbsb';btn.innerHTML='→';
  let errEl=null;
  const go=()=>{
    const v=inp.value.trim();
    if(!v&&!step.optional){inp.classList.add('invalid');inp.focus();return;}
    if(!v&&step.optional){S.answers[step.id]='';next(idx,'（スキップ）');return;}
    if(step.validate){
      const msg=step.validate(v);
      if(msg){inp.classList.add('invalid');if(errEl)errEl.remove();errEl=document.createElement('div');errEl.className='cbb err';errEl.textContent='⚠️ '+msg;$m().appendChild(errEl);scrollB();setTimeout(()=>inp.focus(),50);return;}
    }
    inp.classList.remove('invalid');S.answers[step.id]=v;next(idx,v);
  };
  btn.onclick=go;inp.onkeydown=e=>{if(e.key==='Enter')go();};inp.oninput=()=>inp.classList.remove('invalid');
  row.appendChild(inp);row.appendChild(btn);area.appendChild(row);
  if(step.hint){const h=document.createElement('div');h.className='cb-hint';h.textContent=step.hint;area.appendChild(h);}
  if(step.optional){
    const sk=document.createElement('div');sk.className='cb-skip-row';
    const sl=document.createElement('button');sl.className='cb-skip';sl.textContent='スキップする';
    sl.onclick=()=>{S.answers[step.id]='';next(idx,'（スキップ）');};
    sk.appendChild(sl);area.appendChild(sk);
  }
  setTimeout(()=>inp.focus(),100);
}

/* ── 郵便番号（自動補完） ── */
function renderZip(area,step,idx){
  const row=document.createElement('div');row.className='cbtr';
  const inp=document.createElement('input');inp.type='tel';inp.className='cbti';inp.placeholder=step.placeholder||'';inp.maxLength=8;
  if(S.answers[step.id])inp.value=S.answers[step.id];
  const btn=document.createElement('button');btn.className='cbsb';btn.innerHTML='→';
  const resultArea=document.createElement('div');
  let detectedAddr='',errEl=null;

  const tryZip=async v=>{
    const c=v.replace(/-/g,'');if(c.length!==7)return null;
    try{const r=await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${c}`);const j=await r.json();if(j.results){const a=j.results[0];return a.address1+a.address2+a.address3;}}catch(e){}return null;
  };

  inp.oninput=async()=>{
    inp.classList.remove('invalid');
    const v=inp.value.replace(/-/g,'');
    if(v.length===7){
      resultArea.innerHTML=`<div class="cbld"><div class="cbspinner"></div> 住所を検索中…</div>`;
      const addr=await tryZip(v);detectedAddr=addr||'';
      if(addr){
        resultArea.innerHTML='';
        const z=document.createElement('div');z.className='cb-zip-result';
        z.innerHTML=`<svg viewBox="0 0 20 20" fill="none" stroke="${B.ok}" stroke-width="2"><path d="M5 10l4 4 6-6"/></svg><span>${addr}</span>`;
        const ed=document.createElement('button');ed.className='cb-zip-edit';ed.textContent='修正する';
        ed.onclick=()=>{resultArea.innerHTML='';detectedAddr='';inp.focus();};
        z.appendChild(ed);resultArea.appendChild(z);
      }else{
        resultArea.innerHTML=`<div class="cbb err" style="margin:0">住所が見つかりませんでした。直接入力してください。</div>`;
      }
    }else resultArea.innerHTML='';
  };

  const go=async()=>{
    const v=inp.value.trim();const clean=v.replace(/-/g,'');
    if(!v){inp.classList.add('invalid');inp.focus();return;}
    if(step.validate){const msg=step.validate(v);if(msg){inp.classList.add('invalid');if(errEl)errEl.remove();errEl=document.createElement('div');errEl.className='cbb err';errEl.textContent='⚠️ '+msg;$m().appendChild(errEl);scrollB();return;}}
    inp.classList.remove('invalid');S.answers[step.id]=clean;area.innerHTML='';bubble(clean,'usr');
    const target=step.zipTarget||'billing';
    const addrKey=target==='shipping'?'ship_addr':'addr';
    const addr2Key=target==='shipping'?'ship_addr2':'addr2';
    let finalAddr=detectedAddr;
    if(!finalAddr&&clean.length===7){showTyping();finalAddr=await tryZip(clean)||'';rmTyping();}
    if(finalAddr){
      S.answers[addrKey]=finalAddr;
      bubble('住所を自動入力しました ✅','ok2');bubble(finalAddr);
      const toIdx=FLOW.findIndex(s=>s.id===addr2Key);
      if(toIdx>=0){S.history.push(idx);run(toIdx);}else next(idx-1,'');
    }else{S.history.push(idx);run(idx+1);}
  };
  btn.onclick=go;inp.onkeydown=e=>{if(e.key==='Enter')go();};
  row.appendChild(inp);row.appendChild(btn);area.appendChild(row);
  if(step.hint){const h=document.createElement('div');h.className='cb-hint';h.textContent=step.hint;area.appendChild(h);}
  area.appendChild(resultArea);
  setTimeout(()=>inp.focus(),100);
}

/* ── 確認画面 ── */
function renderConfirm(idx){
  const area=$i();const a=S.answers;const isDiff=a['diff_ask']==='yes';
  const sum=document.createElement('div');sum.className='cbsum';
  const sec=t=>{const d=document.createElement('div');d.className='cbsec';d.textContent=t;sum.appendChild(d);};
  const row=(k,v)=>{const d=document.createElement('div');d.className='cbsr';d.innerHTML=`<span class="cbsk2">${k}</span><span class="cbsv">${v||'—'}</span>`;sum.appendChild(d);};
  sec('ご注文内容');
  row('商品',a.product_label+(a.product_is_sub?' 【定期】':''));
  row('数量',(a.qty||1)+'個');
  row('金額',fmt((a.product_price||0)*(a.qty||1)));
  row('お支払い',a.payment_label);
  sec('お客様情報');
  row('お名前',a.name);row('メール',a.email);row('電話番号',a.phone);
  row('郵便番号',a.zip);row('住所',a.addr);if(a.addr2)row('建物名',a.addr2);
  sec('お届け先');
  if(isDiff){row('お名前',a.ship_name);row('郵便番号',a.ship_zip);row('住所',a.ship_addr);if(a.ship_addr2)row('建物名',a.ship_addr2);}
  else row('','お客様情報と同じ');
  const btns=document.createElement('div');btns.className='cbcb';
  const ok=document.createElement('button');ok.className='cbcok';ok.textContent='✓ この内容で注文する';
  ok.onclick=()=>{area.innerHTML='';submitOrder();};
  const bk=document.createElement('button');bk.className='cbcbk';bk.textContent='最初からやり直す';
  bk.onclick=()=>{$m().innerHTML='';area.innerHTML='';Object.keys(S.answers).forEach(k=>delete S.answers[k]);S.history=[];S.idx=0;run(0);};
  btns.appendChild(ok);btns.appendChild(bk);
  area.appendChild(sum);area.appendChild(btns);area.appendChild(makeBackRow(goBack));
  $p().style.width='95%';$l().textContent='確認';
}

/* ── SUBMIT ── */
async function submitOrder(){
  const area=$i();
  area.innerHTML=`<div class="cbld"><div class="cbspinner"></div> 注文を送信中…</div>`;
  const a=S.answers;const isDiff=a['diff_ask']==='yes';
  const billingAddr=a.addr+(a.addr2?' '+a.addr2:'');
  const shippingAddr=isDiff?(a.ship_addr+(a.ship_addr2?' '+a.ship_addr2:'')):billingAddr;

  /* selling_plan があれば items に含める */
  const item={
    id:parseInt(a.product_id),
    quantity:parseInt(a.qty)||1,
    properties:{
      'お名前':          a.name,
      'メールアドレス':  a.email,
      '電話番号':        a.phone,
      '請求先郵便番号':  a.zip,
      '請求先住所':      billingAddr,
      'お届け先氏名':    isDiff?a.ship_name:a.name,
      'お届け先郵便番号':isDiff?a.ship_zip:a.zip,
      'お届け先住所':    shippingAddr,
      'お支払い方法':    a.payment_label,
      '注文タイプ':      a.product_is_sub?'定期購入':'通常購入',
      '注文経路':        'チャットボット',
    }
  };
  if(a.product_selling_plan){
    item.selling_plan=parseInt(a.product_selling_plan);
  }

  try{
    const res=await fetch(CFG.cartEndpoint,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[item]})
    });
    if(!res.ok)throw new Error(res.status);
    area.innerHTML='';$p().style.width='100%';$l().textContent='';
    showPaymentGuide(CFG.paymentMethods.find(p=>p.id===a.payment_id)||CFG.paymentMethods[0]);
  }catch(e){
    area.innerHTML='';
    bubble('⚠️ 送信中にエラーが発生しました。\n通信環境を確認して再度お試しください。');
    const rb=document.createElement('button');rb.className='cbcok';rb.style.width='100%';rb.style.marginTop='8px';
    rb.textContent='再試行する';rb.onclick=()=>{area.innerHTML='';submitOrder();};
    $i().appendChild(rb);
  }
}

/* ── 決済案内（別タブ統一） ── */
function showPaymentGuide(pm){
  const area=$i();area.innerHTML='';
  const card=document.createElement('div');card.className='cb-guide-card';
  const icon=document.createElement('div');icon.className='cb-guide-icon';icon.textContent=pm.icon||'💳';
  const text=document.createElement('div');text.className='cb-guide-text';text.textContent=pm.guide||'';
  const openBtn=document.createElement('button');openBtn.className='cb-guide-open';
  openBtn.innerHTML=`${SVG_EXT} 別タブで決済画面を開く`;
  openBtn.onclick=()=>{window.open(CFG.checkoutUrl,'_blank','noopener');showWaitingScreen(pm);};
  const btns=document.createElement('div');btns.className='cb-guide-btns';btns.appendChild(openBtn);
  card.appendChild(icon);card.appendChild(text);card.appendChild(btns);
  area.appendChild(card);scrollB();
}

/* ── 待機画面 ── */
function showWaitingScreen(pm){
  const area=$i();area.innerHTML='';
  const wrap=document.createElement('div');wrap.className='cb-waiting';
  const spinWrap=document.createElement('div');spinWrap.style.cssText='position:relative;width:48px;height:48px;flex-shrink:0';
  spinWrap.innerHTML=`<div class="cb-waiting-spinner" style="width:48px;height:48px;border-width:4px"></div><div style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:20px">${pm.icon||'💳'}</div>`;
  const msg=document.createElement('div');msg.className='cb-waiting-text';
  msg.innerHTML=`<strong>${pm.label}</strong>の決済画面を別タブで開きました。<br><br>お支払いが完了したら<br>下のボタンを押してください。`;
  const doneBtn=document.createElement('button');doneBtn.className='cb-waiting-done';
  doneBtn.textContent='✓ 支払いが完了しました';
  doneBtn.onclick=()=>{area.innerHTML='';showSuccess(pm.label);};
  const reopenWrap=document.createElement('div');reopenWrap.style.cssText='margin-top:4px;text-align:center';
  const reopenBtn=document.createElement('button');reopenBtn.className='cb-skip';reopenBtn.textContent='決済画面をもう一度開く';
  reopenBtn.onclick=()=>window.open(CFG.checkoutUrl,'_blank','noopener');
  reopenWrap.appendChild(reopenBtn);
  wrap.appendChild(spinWrap);wrap.appendChild(msg);wrap.appendChild(doneBtn);wrap.appendChild(reopenWrap);
  area.appendChild(wrap);scrollB();
}

/* ── 完了画面 ── */
function showSuccess(payLabel){
  $m().innerHTML='';
  const d=document.createElement('div');d.className='cbsc';
  d.innerHTML=`
    <div class="cbsr2">🎉</div>
    <div class="cbst2">ご注文ありがとうございます！</div>
    <div class="cbsb2">${payLabel}でのお支払いが完了しました。<br><br>ご注文確認メールをお送りしますので<br>ご確認ください。<br><br>引き続き monster-deri を<br>よろしくお願いいたします 🥩</div>`;
  $m().appendChild(d);$i().innerHTML='';scrollB();
}

/* ── TOGGLE ── */
function openChat(){
  S.open=true;win.classList.add('open');
  fab.querySelector('.cbfd').style.display='none';
  if(!S.started){S.started=true;setTimeout(()=>run(0),350);}
}
function closeChat(){S.open=false;win.classList.remove('open');}
fab.addEventListener('click',()=>S.open?closeChat():openChat());
document.getElementById('cbcl').addEventListener('click',closeChat);
if(UI.autoOpen)setTimeout(openChat,UI.autoOpenDelay);

})();